import { Controller } from "@hotwired/stimulus"

// Debounced auto-submit for the contacts search input. Walks up to the
// closest <form> and calls requestSubmit() once typing pauses. The
// form itself lives at the call site — this controller has no opinion
// on the URL, method, or target frame.
export default class extends Controller {
  static targets = ["input"]
  static values = { delay: { type: Number, default: 300 } }

  initialize() {
    this.timer = null
  }

  queue() {
    if (this.timer) clearTimeout(this.timer)
    this.timer = setTimeout(() => this.submit(), this.delayValue)
  }

  submit() {
    const form = this.element.closest("form")
    if (form) form.requestSubmit()
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }
}
